import { Button, Form, Input, Switch } from "antd";
import * as React from "react";
import { useEffect, useState } from "react";
import { sendRequest } from "../../utils/sendRequest";
import { phoneValidator } from "../../utils/validators";
import { Azienda, Utente } from "../../API";
import { useParams } from "react-router-dom";
import { customAlphabet } from "nanoid";
import { openNotificationError } from "../../utils/openNotification";
import AziendaDropdown from "../AziendaDropdown/AziendaDropdown";
import Radio from "../Radio/Radio";
import BottomBar from "../BottomBar/BottomBar";
import TooltipInput from "../TooltipInput/TooltipInput";

interface IProps {
  initialValues?: Utente;
  onAfterSubmit?: () => void;
}

const AddUtenteForm = ({ initialValues, onAfterSubmit }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [abilitato, setAbilitato] = useState("Attivo");
  const { editKey } = useParams();
  const initialPassword = React.useMemo(() => {
    return customAlphabet("1234567890", 5)();
  }, []);

  useEffect(() => {
    if (initialValues)
      setAbilitato(initialValues?.abilitato ? "Attivo" : "Non attivo");
  }, [initialValues]);

  const onFinish = async (data: any) => {
    if (data.password !== data.ripassword) {
      throw new Error("Password do not match");
      return;
    }
    setLoading(true);
    delete data.ripassword;
    delete data.abilitato;

    if (!!editKey) {
      await sendRequest(
        "updateUtente",
        {
          input: {
            username: editKey,
            abilitato: abilitato === "Attivo" ? true : false,
            ...data,
          },
        },
        true
      );
    } else {
      await sendRequest(
        "createUtente",
        {
          input: {
            abilitato: abilitato === "Attivo" ? true : false,
            ...data,
          },
        },
        true
      );
    }
    onAfterSubmit?.();
    setLoading(false);
  };
  const onFinishFailed = () => {};

  return (
    <Form
      initialValues={{
        ...initialValues,
        ripassword: initialValues?.password,
      }}
      key={JSON.stringify(initialValues)}
      layout={"vertical"}
      name="basic"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <div className={"formRow"}>
        <AziendaDropdown />

        <Form.Item
          style={{ flex: 1 }}
          name="nome"
          rules={[{ required: false, message: "Campo richiesto" }]}
        >
          <TooltipInput placeholder="Nome e Cognome" />
        </Form.Item>
        <Form.Item
          style={{ flex: 1 }}
          name="username"
          rules={[{ required: true, message: "Campo richiesto" }]}
        >
          <Input placeholder="Username" />
        </Form.Item>
      </div>
      <div className={"formRow"}>
        <Form.Item
          style={{ flex: 1 }}
          name="email"
          rules={[
            { type: "email", required: false, message: "Campo richiesto" },
          ]}
        >
          <TooltipInput placeholder="E-mail" />
        </Form.Item>
        <Form.Item
          style={{ flex: 1 }}
          name="password"
          initialValue={initialPassword}
          rules={[{ required: true, message: "Campo richiesto" }]}
        >
          <TooltipInput placeholder={"Password"} />
        </Form.Item>
        <Form.Item
          style={{ flex: 1 }}
          initialValue={initialPassword}
          name="ripassword"
          rules={[{ required: true, message: "Campo richiesto" }]}
        >
          <TooltipInput placeholder={"Ripeti Password"} />
        </Form.Item>
      </div>
      <Radio
        options={["Attivo", "Non attivo"]}
        value={abilitato}
        setValue={setAbilitato}
      />
      <BottomBar absolute>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button size={"large"} onClick={() => window.history.back()}>
            Annulla
          </Button>
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            htmlType="submit"
            size={"large"}
            type={"primary"}
            loading={loading}
          >
            {editKey ? "Salva" : "Inserisci Utente"}
          </Button>
        </Form.Item>
      </BottomBar>
    </Form>
  );
};

export default AddUtenteForm;
